import { render, staticRenderFns } from "./ControlLibraryColor.vue?vue&type=template&id=785cb890&scoped=true&"
import script from "./ControlLibraryColor.vue?vue&type=script&lang=js&"
export * from "./ControlLibraryColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785cb890",
  null
  
)

export default component.exports